export const categories = [
  { id: 1, name: "音乐综艺", slug: "music", icon: "ri-music-2-line", description: "音乐竞演、歌唱比赛、音乐真人秀等音乐类综艺节目" },
  { id: 2, name: "户外真人秀", slug: "outdoor", icon: "ri-landscape-line", description: "户外挑战、旅行探险、野外生存等户外真人秀节目" },
  { id: 3, name: "脱口秀", slug: "talkshow", icon: "ri-chat-smile-2-line", description: "脱口秀、喜剧表演、语言类节目" },
  { id: 4, name: "竞技挑战", slug: "competition", icon: "ri-trophy-line", description: "竞技比赛、游戏挑战、体力脑力对决" },
  { id: 5, name: "生活观察", slug: "lifestyle", icon: "ri-heart-line", description: "生活观察、情感交流、慢综艺等生活类节目" },
  { id: 6, name: "美食综艺", slug: "food", icon: "ri-restaurant-line", description: "美食制作、美食探店、烹饪比赛" },
  { id: 7, name: "喜剧搞笑", slug: "comedy", icon: "ri-emotion-laugh-line", description: "喜剧小品、搞笑综艺、欢乐真人秀" },
  { id: 8, name: "访谈对话", slug: "interview", icon: "ri-mic-line", description: "名人访谈、深度对话、人物专题" },
];